import { Dispatch } from 'react';
import { DiscountRuleFilters, DiscountRuleModel } from '../../../api/pricing/pricing.types';
import { PricingApi } from '../../../api/api.apiclient';
import { PageRequest } from '../../../api/api.types';
import {
  DELETE_DISCOUNT_RULE,
  DeleteDiscountRuleAction,
  GET_DISCOUNT_RULE,
  GET_DISCOUNT_RULES_LIST,
  POST_DISCOUNT_RULE,
  PUT_DISCOUNT_RULE, UPDATE_DISCOUNT_RULE_FILTERS, UpdateDiscountRuleFiltersAction
} from '../types/discountrule.types';

export const getDiscountRulesList = (filters?: DiscountRuleFilters, page?: PageRequest) => async (dispatch: Dispatch<any>) => {
  const response = await PricingApi.DiscountRules.listAllDiscountRules(filters, page);

  dispatch({
    type: GET_DISCOUNT_RULES_LIST,
    payload: {
      page: response.data
    }
  });
  return Promise.resolve();
};

export const getDiscountRule = (id: number) => async (dispatch: Dispatch<any>): Promise<any> => {
  try {
    const response = await PricingApi.DiscountRules.getDiscountRule(id);

    dispatch({
      type: GET_DISCOUNT_RULE,
      payload: {
        selectedDiscountRule: response.data
      }
    });

    return Promise.resolve();
  } catch (e) {
    dispatch({
      type: GET_DISCOUNT_RULE,
      payload: {
        selectedDiscountRule: null
      }
    });

    return Promise.reject();
  }
};

export const editDiscountRule = (id: number, request: DiscountRuleModel) => async (dispatch: Dispatch<any>) => {
  const response = await PricingApi.DiscountRules.editDiscountRule(id, request);

  dispatch({
    type: PUT_DISCOUNT_RULE,
    payload: {
      selectedDiscountRule: response.data
    }
  });
};

export const addNewDiscountRule = (request: DiscountRuleModel) => async (dispatch: Dispatch<any>) => {
  const response = await PricingApi.DiscountRules.addNewDiscountRule(request);

  dispatch({
    type: POST_DISCOUNT_RULE,
    payload: {
      newDiscountRule: response.data,
      success: true
    }
  });
};

export const deleteDiscountRule = (id: number) => async (dispatch: Dispatch<DeleteDiscountRuleAction>) => {
  await PricingApi.DiscountRules.deleteDiscountRule(id);
  dispatch({
    type: DELETE_DISCOUNT_RULE,
    payload: {
      success: true
    }
  });
};

export const updateDiscountRuleFilters = (filters: DiscountRuleFilters) => async (dispatch: Dispatch<UpdateDiscountRuleFiltersAction>) => {
  dispatch({
    type: UPDATE_DISCOUNT_RULE_FILTERS,
    payload: {
      filters
    }
  });
};
